var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',[(_vm.isShowModal)?_c('SimpleModal',{attrs:{"title":_vm.message},on:{"close":function($event){_vm.isShowModal=false}}}):_vm._e(),_c('router-view',{key:_vm.key})],1)}
var staticRenderFns = []

export { render, staticRenderFns }